import React from 'react'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="none">
        <path
          d="M89.948 90.262c0 1.247-.525 2.444-1.47 3.342A5.103 5.103 0 0 1 84.96 95H14.987c-1.312 0-2.625-.499-3.517-1.396-.945-.898-1.47-2.095-1.47-3.342V4.738c0-1.247.525-2.494 1.47-3.342C12.362.5 13.675 0 14.987 0h42.94c1.312 0 2.624.499 3.57 1.396L88.53 27.08a4.632 4.632 0 0 1 1.47 3.39v59.793h-.052Z"
          fill="#EBECF0"
        />
        <path
          d="M90 91v5c0 1.316-.525 2.632-1.47 3.526A4.967 4.967 0 0 1 85.01 101H14.99c-2.784 0-4.99-2.263-4.99-5v-5c0 1.316.525 2.579 1.47 3.526A4.967 4.967 0 0 0 14.99 96h70.02c2.784 0 4.99-2.263 4.99-5Z"
          fill="#C1C7D0"
        />
        <path
          d="M0 52h100v24.175C100 78.867 97.743 81 95.013 81H5.04c-1.312 0-2.624-.508-3.517-1.422a4.758 4.758 0 0 1-1.47-3.454V52H0Z"
          fill="#009688"
        />
        <path d="M10 53V43L0 53h10Zm80 0 .104-10L100 53H90Z" fill="#006F65" />
        <path
          d="M89.996 30.354V31H62.983C60.203 31 58 28.864 58 26.28V0c1.311 0 2.623.497 3.567 1.391l27.066 25.585c.891.894 1.416 2.087 1.363 3.378Z"
          fill="#C1C7D0"
        />
        <path fill="#C1C7D0" opacity={0.2} d="m65 26 25 25-.073-21.19z" />
        <text fill="#FFF">
          <tspan x={33} y={73}>
            XLS
          </tspan>
        </text>
      </g>
    </svg>
  )
}
const XlsIcon = (props) => {
  const { width, height } = props
  return (
    <div style={{ width, height }}>
      <Icon />
    </div>
  )
}

// 默认参数
XlsIcon.defaultProps = {
  width: 12,
  height: 12,
}
// 参数类型
XlsIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default XlsIcon
